module.exports = __webpack_public_path__ + "fonts/DMSans-Medium.fbbc5a51.ttf";